//====================================================
//  Initialization Map
//====================================================


function fn_components_object_map(){
	$('.object-map .map-block').each(function() {
		var inst = $(this);
		var id = inst.attr('id');
		fn_components_map_init(id);
	});

}



function fn_components_map_init(mapId){
	if (mapId == 'map-footer'){
		var optionStyles = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]}];
	}

	if (mapId == 'map-partners'){
		var optionStyles = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}];
	}

	var map
	var mapOptions = {
		zoom: 8,
		panControl: false,
		zoomControl: true,
		mapTypeControl: false,
		streetViewControl: false,
		scrollwheel: false,
		//draggable: false,
		center: new google.maps.LatLng(50.0809813, 14.396636),
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		styles: optionStyles
	};
	map = new google.maps.Map(document.getElementById(mapId), mapOptions);

	var gmarkers = [];
	var bounds = new google.maps.LatLngBounds();
	var objects = [];
	
	function markerSet(image){
		return new google.maps.MarkerImage(
			image,
			new google.maps.Size(79, 68),
			// The origin for my image is 0,0.
			new google.maps.Point(0, 0),
			// The center of the image is 50,50 (my image is a circle with 100,100)
			new google.maps.Point(39, 34)
		);
	}

	// function markerSetObject(image){
	//     return new google.maps.MarkerImage(
	//         image,
	//         new google.maps.Size(43, 56),
	//         // The origin for my image is 0,0.
	//         new google.maps.Point(0, 0),
	//         // The center of the image is 50,50 (my image is a circle with 100,100)
	//         new google.maps.Point(21, 56)
	//     );
	// }

	var ms_ie = false;
	var ua = window.navigator.userAgent;
	var old_ie = ua.indexOf('MSIE ');
	var new_ie = ua.indexOf('Trident/');

	if ((old_ie > -1) || (new_ie > -1)) {
		ms_ie = true;
	}

	if ( ms_ie ) {
		var markerM = markerSet('images/marker/map-marker-m.png');
		var markerA = markerSet('images/marker/map-marker-a.png');
	} else {
		var markerM = markerSet('images/marker/map-marker-m.svg');
		var markerA = markerSet('images/marker/map-marker-a.svg');
	}


	if (mapId == 'map-footer'){
		var markers = [
			{
				"id": '0',
				"icon": markerM,
				"content":  '<div class="popup-header">' +
							'<div class="footer-title footer-title-small">Melecky a.s.</div>' +
							'<div class="footer-text footer-text-small">Čermenská 910, 749 01, Vítkov Česká republika</div>' +
						  '</div>' +
						  '<div class="popup-content">' +
							'<ul class="contact-list">' +
								'<li class="contact-list-item">' +
									'<a href="tel:+420556300578" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-phone"></span>' +
										'<span class="contact-list-text">+420 556 300 578</span>' +
									'</a>' +
								'</li>' +
								'<li class="contact-list-item">' +
									'<a href="tel:+420556300579" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-phone-2"></span>' +
										'<span class="contact-list-text">+420 556 300 579</span>' +
									'</a>' +
								'</li>' +
								'<li class="contact-list-item">' +
									'<a href="mailto:info@melecky.cz" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-mail"></span>' +
										'<span class="contact-list-text txt-underline">info@melecky.cz</span>' +
									'</a>' +
								'</li>' +
							'</ul>' +
						  '</div>',
				"longitude": 49.116730,
				"latitude": 16.723195
			},
			{
				"id": '1',
				"icon": markerM,
				"content":  '<div class="popup-header">' +
							'<div class="footer-title footer-title-small">Melecky a.s.</div>' +
							'<div class="footer-text footer-text-small">Čermenská 910, 749 01, Vítkov Česká republika</div>' +
						  '</div>' +
						  '<div class="popup-content">' +
							'<ul class="contact-list">' +
								'<li class="contact-list-item">' +
									'<a href="tel:+420556300578" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-phone"></span>' +
										'<span class="contact-list-text">+420 556 300 578</span>' +
									'</a>' +
								'</li>' +
								'<li class="contact-list-item">' +
									'<a href="tel:+420556300579" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-phone-2"></span>' +
										'<span class="contact-list-text">+420 556 300 579</span>' +
									'</a>' +
								'</li>' +
								'<li class="contact-list-item">' +
									'<a href="mailto:info@melecky.cz" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-mail"></span>' +
										'<span class="contact-list-text txt-underline">info@melecky.cz</span>' +
									'</a>' +
								'</li>' +
							'</ul>' +
						  '</div>',
				"longitude": 49.114647,
				"latitude": 16.731001
			}, {
				"id": '2',
				"icon": markerA,
				"content":  '<div class="popup-header">' +
							'<div class="footer-title footer-title-small">Melecky a.s.</div>' +
							'<div class="footer-text footer-text-small">Čermenská 910, 749 01, Vítkov Česká republika</div>' +
						  '</div>' +
						  '<div class="popup-content">' +
							'<ul class="contact-list">' +
								'<li class="contact-list-item">' +
									'<a href="tel:+420556300578" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-phone"></span>' +
										'<span class="contact-list-text">+420 556 300 578</span>' +
									'</a>' +
								'</li>' +
								'<li class="contact-list-item">' +
									'<a href="tel:+420556300579" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-phone-2"></span>' +
										'<span class="contact-list-text">+420 556 300 579</span>' +
									'</a>' +
								'</li>' +
								'<li class="contact-list-item">' +
									'<a href="mailto:info@melecky.cz" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-mail"></span>' +
										'<span class="contact-list-text txt-underline">info@melecky.cz</span>' +
									'</a>' +
								'</li>' +
							'</ul>' +
						  '</div>',
				"longitude": 49.117970,
				"latitude": 16.718455
			}
		]
	}

	if (mapId == 'map-partners'){
		var markers = [
			{
				"id": '0',
				"icon": markerM,
				"content":  '<div class="popup-header">' +
							'<div class="footer-title footer-title-small">Melecky a.s.</div>' +
							'<div class="footer-text footer-text-small">Čermenská 910, 749 01, Vítkov Česká republika</div>' +
						  '</div>' +
						  '<div class="popup-content">' +
							'<ul class="contact-list">' +
								'<li class="contact-list-item">' +
									'<a href="tel:+420556300578" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-phone"></span>' +
										'<span class="contact-list-text">+420 556 300 578</span>' +
									'</a>' +
								'</li>' +
								'<li class="contact-list-item">' +
									'<a href="tel:+420556300579" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-phone-2"></span>' +
										'<span class="contact-list-text">+420 556 300 579</span>' +
									'</a>' +
								'</li>' +
								'<li class="contact-list-item">' +
									'<a href="mailto:info@melecky.cz" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-mail"></span>' +
										'<span class="contact-list-text txt-underline">info@melecky.cz</span>' +
									'</a>' +
								'</li>' +
							'</ul>' +
						  '</div>',
				"longitude": 49.116730,
				"latitude": 16.723195
			},
			{
				"id": '1',
				"icon": markerM,
				"content":  '<div class="popup-header">' +
							'<div class="footer-title footer-title-small">Melecky a.s.</div>' +
							'<div class="footer-text footer-text-small">Čermenská 910, 749 01, Vítkov Česká republika</div>' +
						  '</div>' +
						  '<div class="popup-content">' +
							'<ul class="contact-list">' +
								'<li class="contact-list-item">' +
									'<a href="tel:+420556300578" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-phone"></span>' +
										'<span class="contact-list-text">+420 556 300 578</span>' +
									'</a>' +
								'</li>' +
								'<li class="contact-list-item">' +
									'<a href="tel:+420556300579" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-phone-2"></span>' +
										'<span class="contact-list-text">+420 556 300 579</span>' +
									'</a>' +
								'</li>' +
								'<li class="contact-list-item">' +
									'<a href="mailto:info@melecky.cz" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-mail"></span>' +
										'<span class="contact-list-text txt-underline">info@melecky.cz</span>' +
									'</a>' +
								'</li>' +
							'</ul>' +
						  '</div>',
				"longitude": 49.114647,
				"latitude": 16.731001
			}, {
				"id": '2',
				"icon": markerA,
				"content":  '<div class="popup-header">' +
							'<div class="footer-title footer-title-small">Melecky a.s.</div>' +
							'<div class="footer-text footer-text-small">Čermenská 910, 749 01, Vítkov Česká republika</div>' +
						  '</div>' +
						  '<div class="popup-content">' +
							'<ul class="contact-list">' +
								'<li class="contact-list-item">' +
									'<a href="tel:+420556300578" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-phone"></span>' +
										'<span class="contact-list-text">+420 556 300 578</span>' +
									'</a>' +
								'</li>' +
								'<li class="contact-list-item">' +
									'<a href="tel:+420556300579" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-phone-2"></span>' +
										'<span class="contact-list-text">+420 556 300 579</span>' +
									'</a>' +
								'</li>' +
								'<li class="contact-list-item">' +
									'<a href="mailto:info@melecky.cz" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-mail"></span>' +
										'<span class="contact-list-text txt-underline">info@melecky.cz</span>' +
									'</a>' +
								'</li>' +
							'</ul>' +
						  '</div>',
				"longitude": 49.117970,
				"latitude": 16.718455
			}, {
				"id": '3',
				"icon": markerM,
				"content":  '<div class="popup-header">' +
							'<div class="footer-title footer-title-small">Melecky a.s.</div>' +
							'<div class="footer-text footer-text-small">Čermenská 910, 749 01, Vítkov Česká republika</div>' +
						  '</div>' +
						  '<div class="popup-content">' +
							'<ul class="contact-list">' +
								'<li class="contact-list-item">' +
									'<a href="tel:+420556300578" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-phone"></span>' +
										'<span class="contact-list-text">+420 556 300 578</span>' +
									'</a>' +
								'</li>' +
								'<li class="contact-list-item">' +
									'<a href="tel:+420556300579" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-phone-2"></span>' +
										'<span class="contact-list-text">+420 556 300 579</span>' +
									'</a>' +
								'</li>' +
								'<li class="contact-list-item">' +
									'<a href="mailto:info@melecky.cz" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-mail"></span>' +
										'<span class="contact-list-text txt-underline">info@melecky.cz</span>' +
									'</a>' +
								'</li>' +
							'</ul>' +
						  '</div>',
				"longitude": 49.116730,
				"latitude": 16.733195
			}, {
				"id": '4',
				"icon": markerM,
				"content":  '<div class="popup-header">' +
							'<div class="footer-title footer-title-small">Melecky a.s.</div>' +
							'<div class="footer-text footer-text-small">Čermenská 910, 749 01, Vítkov Česká republika</div>' +
						  '</div>' +
						  '<div class="popup-content">' +
							'<ul class="contact-list">' +
								'<li class="contact-list-item">' +
									'<a href="tel:+420556300578" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-phone"></span>' +
										'<span class="contact-list-text">+420 556 300 578</span>' +
									'</a>' +
								'</li>' +
								'<li class="contact-list-item">' +
									'<a href="tel:+420556300579" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-phone-2"></span>' +
										'<span class="contact-list-text">+420 556 300 579</span>' +
									'</a>' +
								'</li>' +
								'<li class="contact-list-item">' +
									'<a href="mailto:info@melecky.cz" class="contact-list-link">' +
										'<span class="contact-list-icon icon icon-mail"></span>' +
										'<span class="contact-list-text txt-underline">info@melecky.cz</span>' +
									'</a>' +
								'</li>' +
							'</ul>' +
						  '</div>',
				"longitude": 49.116730,
				"latitude": 16.753195
			}
		]
	}




	for (var i = 0; i < markers.length; ++i) {
		var template = markers[i].content;
		objects.push(template);
	}


	for (var i = 0; i < markers.length; ++i) {
		var latLng = new google.maps.LatLng(markers[i].longitude, markers[i].latitude)
		var marker = new google.maps.Marker({
			position: latLng,
			draggable: false,
			icon: markers[i].icon,
			id: markers[i].id,
			active: markers[i].active,
			name: objects[i]
		});

		var infoWindow = new google.maps.InfoWindow({
			pixelOffset: new google.maps.Size(-200, 95),
			maxWidth: 240
		}), marker, i;

		google.maps.event.addListener(marker, 'click', function(e){
			if (this.id.length){
				infoWindow.setContent(this.name);
				infoWindow.open(map, this);
				$('.gm-style-iw').parent().addClass('window-block');
			}
		});

		google.maps.event.addListener(infoWindow,'closeclick',function(){
			for (var j = 0; j < gmarkers.length; j++) {
				gmarkers[j].setIcon(markers[j].icon);
			}
		});

		google.maps.event.addListener(infoWindow, 'domready', function() {
			var iwOuter = $('.gm-style-iw');
			var iwBackground = iwOuter.prev();
			iwBackground.children(':nth-child(2)').css({'display' : 'none'});
			iwBackground.children(':nth-child(4)').css({'display' : 'none'});

			var iwCloseBtn = iwOuter.next();
			iwCloseBtn.css({width: '40px', height:'40px', opacity: '1', marginLeft:'0', right:'15px', top: '0', 'border-radius': '0'});
			
			iwCloseBtn.click(function(){
				infoWindow.close();
			});

			iwCloseBtn.mouseout(function(){
				$(this).css({opacity: '1'});
			});
		});


		bounds.extend(marker.position);
		marker.setMap(map);
		gmarkers.push(marker);
	}

	map.fitBounds(bounds);
}


